import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import SelectField from '../../shared/form-elements/multiselect/select';

lessRequire('modules/finances/components/categories-filter.less');

const propTypes = {
	handleSubmit: PropTypes.func,
	intl: PropTypes.func,
	categoriesFilterData: PropTypes.object
};

const Form = ({ intl, handleSubmit, categoriesFilterData }) => (
	<form
		action="#"
		className="finances-categories-filter">
		<div className="finances-categories-filter__item">
			<Field
				name="category"
				placeholder={intl('Категория')}
				component={SelectField}
				options={categoriesFilterData.options}
				multi={false}
			/>
		</div>
	</form>
);

Form.propTypes = propTypes;
export default reduxForm({
	form: 'categoriesFilter'
})(Form);




// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/components/categories-filter.js